<template>

  <month-base-bar>
    {{ title }}
  </month-base-bar>

</template>

<script setup lang="ts">

import { computed } from 'vue'
import MonthBaseBar from './MonthBaseBar.vue'
import type { MonthNormalInventoryCalendarItem } from '../../calendarItemTypes'

/**
 * Props
 */

interface Props {
  item: MonthNormalInventoryCalendarItem
}

const props = defineProps<Props>()

const title = computed(() => {
  return `${props.item.spacesSold}/${props.item.spacesTotal} – ${props.item.locationProduct.product.name}`
})

</script>
